import { useSetPageTitle } from "src/hooks/useSetPageTitle";
import { AppLayout } from "src/components/layout/app-layout";
import ManageClientsTab from "./tabs/manage-clients.tab";
import ManageAccountsTab from "./tabs/manage-accounts.tab";
import ManageCampaignsTab from "./tabs/manage-campaigns.tab";
import SettingsTab from "./tabs/settings.tab";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

const ClientManagementPage = () => {
  const navigate = useNavigate();
  const { tab } = useParams<{ tab?: string }>();
  const [searchParams] = useSearchParams();

  const clientManagementTabs = [
    {
      id: '',
      key: 'clients',
      label: 'Clients',
    },
    {
      id: 'manage-accounts',
      key: 'accounts',
      label: 'Accounts',
    },
    {
      id: 'manage-campaigns',
      key: 'campaigns',
      label: 'Campaigns',
    },
    {
      id: 'settings',
      key: 'settings',
      label: 'Settings',
    },
  ];

  const validTabs = clientManagementTabs.map(tab => tab.id);
  type TabType = typeof validTabs[number];

  const currentTab: TabType = validTabs.includes(tab as TabType)
    ? (tab as TabType)
    : '';

  const pageTitle =
    clientManagementTabs.find((t) => t.id === currentTab)?.label ?? 'Clients';
  useSetPageTitle(pageTitle);

  const handleTabChange = (tabId: string) => {
    const qs = searchParams.toString();
    navigate(`/manage-clients/${tabId}${qs ? `?${qs}` : ''}`);
  };

  return (
    <AppLayout
      activePage="/client-management"
      navbarProps={{
        tabs: clientManagementTabs,
        activeTab: currentTab,
        onTabChange: handleTabChange,
      }}
    >

      <div className="h-[calc(100vh-8rem)]">
        {currentTab === '' && <ManageClientsTab />}
        {currentTab === 'manage-accounts' && <ManageAccountsTab />}
        {currentTab === 'manage-campaigns' && <ManageCampaignsTab />}
        {currentTab === 'settings' && <SettingsTab />}
      </div>

    </AppLayout>
  );
};

export default ClientManagementPage;
